/* BBDP 2026-10-16 — Fiche produit (demande de Luc, 16/10 17 h 59)
   1. Aucune pointure présélectionnée : à l'arrivée sur la fiche (sans ?variant= dans l'adresse), la pointure
      cochée par défaut est décochée ; « Ajouter au panier » et le paiement express attendent le choix
      d'une pointure (bouton « Choisissez votre pointure »). Le choix d'une pointure rend la main au thème.
   2. Barre « Ajouter au panier » collée en bas de l'écran sur mobile, visible quand le bouton d'origine
      est hors de l'écran ; elle appuie sur le bouton d'origine, ou ramène aux pointures si aucune n'est choisie.
   Aucune requête réseau supplémentaire. */
(function () {
  if (window.__bbdpProduct) return;
  window.__bbdpProduct = true;

  /* Test A/B « fiche produit mobile » (décision de Luc, 16/10 18 h 32) :
     A = fiche actuelle ; B = photo réduite + barre « Ajouter au panier » collée en bas.
     Tirage 50/50 par visiteuse, gardé 60 jours (cookie bbdp_ab_pdp). Forçage pour la recette : ?bbdp_ab=A ou ?bbdp_ab=B.
     La variante est envoyée dans le dataLayer (bbdp_ab_pdp) et en attribut de panier caché (_bbdp_ab_pdp),
     visible sur les commandes Shopify, pour comparer ajout au panier et commandes par variante. */
  // Le tirage est fait plus tôt par le petit script en ligne de snippets/bbdp-product-swatches.liquid
  // (pour que la photo ait sa taille finale dès le premier affichage) ; on le relit ici.
  var AB = document.documentElement.classList.contains('bbdp-pdp-b') ? 'B' : 'A';
  try {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'bbdp_ab_pdp', bbdp_ab_pdp: AB });
    if (!sessionStorage.getItem('bbdp_ab_pdp_cart')) {
      sessionStorage.setItem('bbdp_ab_pdp_cart', AB);
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { _bbdp_ab_pdp: AB } })
      }).catch(function () {});
    }
  } catch (e) {}

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var form = document.querySelector('product-info product-form, product-form');
    var submit = document.querySelector('product-info .product-form__submit') || document.querySelector('.product-form__submit');
    var picker = document.querySelector('product-info variant-radios, product-info variant-selects') ||
      document.querySelector('variant-radios, variant-selects');
    var sizeFieldset = null;
    if (picker) {
      var sets = picker.querySelectorAll('fieldset');
      for (var i = 0; i < sets.length; i++) {
        var lg = (sets[i].querySelector('legend') || {}).textContent || '';
        if (/taille|pointure|size/i.test(lg) && sets[i].querySelectorAll('input[type=radio]').length > 1) sizeFieldset = sets[i];
      }
    }
    var productForm = submit ? submit.closest('form') : null;
    var payment = productForm ? productForm.parentElement.querySelector('.shopify-payment-button') : null;

    function chosenSize() {
      if (!sizeFieldset) return 'n/a';
      var c = sizeFieldset.querySelector('input[type=radio]:checked');
      return c ? c.value : null;
    }

    /* 1. Pas de pointure présélectionnée */
    var label = submit ? submit.querySelector('span') : null;
    var originalText = label ? label.textContent : '';
    if (sizeFieldset && submit && !/[?&]variant=/.test(window.location.search)) {
      var radios = sizeFieldset.querySelectorAll('input[type=radio]');
      for (var r = 0; r < radios.length; r++) radios[r].checked = false;
      submit.setAttribute('disabled', 'disabled');
      submit.setAttribute('data-bbdp-wait-size', '');
      if (label) label.textContent = 'Choisissez votre pointure';
      if (payment) payment.classList.add('bbdp-hidden-until-size');
      sizeFieldset.addEventListener('change', function () {
        submit.removeAttribute('data-bbdp-wait-size');
        if (payment) payment.classList.remove('bbdp-hidden-until-size');
        sizeFieldset.classList.remove('bbdp-size-required');
        // le thème met à jour le bouton (disponible / épuisé) ; on rétablit le texte s'il n'a pas changé
        setTimeout(function () {
          if (label && label.textContent === 'Choisissez votre pointure') label.textContent = originalText;
          syncBar();
        }, 400);
      });
    }

    /* 2. Barre collée en bas (mobile) */
    var bar = document.querySelector('[data-bbdp-sticky-atc]');
    if (!bar || !submit) return;
    if (AB !== 'B') { bar.parentNode.removeChild(bar); return; } // barre seulement dans la variante B
    document.body.appendChild(bar);
    var barButton = bar.querySelector('[data-bbdp-sticky-button]');
    var barSize = bar.querySelector('[data-bbdp-sticky-size]');
    var mobile = window.matchMedia('(max-width: 749px)');

    function syncBar() {
      var s = chosenSize();
      if (barSize) barSize.textContent = s && s !== 'n/a' ? 'Pointure ' + s : '';
      var waiting = submit.hasAttribute('data-bbdp-wait-size');
      var soldOut = submit.disabled && !waiting;
      barButton.textContent = waiting ? 'Choisir ma pointure' : (soldOut ? (label ? label.textContent.trim() : 'Épuisé') : 'Ajouter au panier');
      barButton.disabled = soldOut;
    }

    var visible = true;
    function toggle() {
      bar.hidden = !(mobile.matches && !visible);
      document.documentElement.classList.toggle('bbdp-sticky-atc-on', !bar.hidden);
    }
    // la barre est visible tant que le bouton d'origine n'est pas à l'écran (au-dessus ou en dessous)
    var ticking = false;
    function measure() {
      ticking = false;
      var r = submit.getBoundingClientRect();
      visible = r.bottom > 0 && r.top < window.innerHeight;
      toggle();
    }
    function onScroll() {
      if (!ticking) { ticking = true; setTimeout(measure, 60); }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    setTimeout(measure, 0);
    if (mobile.addEventListener) mobile.addEventListener('change', toggle);

    barButton.addEventListener('click', function () {
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'bbdp_sticky_atc_click', bbdp_size_chosen: !!chosenSize() });
      } catch (e) {}
      if (submit.hasAttribute('data-bbdp-wait-size') || !chosenSize()) {
        (sizeFieldset || picker || submit).scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (sizeFieldset) {
          sizeFieldset.classList.remove('bbdp-size-required');
          void sizeFieldset.offsetWidth;
          sizeFieldset.classList.add('bbdp-size-required');
        }
        return;
      }
      submit.click();
    });

    if (picker) picker.addEventListener('change', function () { setTimeout(syncBar, 400); });
    syncBar();
    toggle();
  });
})();
